var map = {
	"./English/Chrome1.png": [
		275,
		51
	],
	"./English/Chrome2.png": [
		276,
		52
	],
	"./English/DuckDuckGo1.png": [
		277,
		53
	],
	"./English/DuckDuckGo2.png": [
		278,
		54
	],
	"./English/Edge1.png": [
		279,
		55
	],
	"./English/Edge2.png": [
		280,
		56
	],
	"./English/Firefox1.png": [
		281,
		57
	],
	"./English/Firefox2.png": [
		282,
		58
	],
	"./English/Opera1.png": [
		283,
		59
	],
	"./English/Opera2.png": [
		284,
		60
	],
	"./English/Safari1.png": [
		285,
		61
	],
	"./English/Safari2.png": [
		286,
		62
	],
	"./English/Samsung1.png": [
		287,
		63
	],
	"./English/Samsung2.png": [
		288,
		64
	],
	"./English/Samsung3.png": [
		289,
		65
	],
	"./German/DuckDuckGoG.png": [
		290,
		66
	],
	"./German/EdgeG.png": [
		291,
		67
	],
	"./German/FirefoxG.png": [
		292,
		68
	],
	"./German/OperaG.png": [
		293,
		69
	],
	"./German/SafariG.png": [
		294,
		70
	],
	"./German/SamsungG1.png": [
		295,
		71
	],
	"./German/SamsungG2.png": [
		296,
		72
	],
	"./Portuguese/DuckDuckGoP.png": [
		297,
		73
	],
	"./Portuguese/EdgeP.png": [
		298,
		74
	],
	"./Portuguese/FirefoxP.png": [
		299,
		75
	],
	"./Portuguese/OperaP.png": [
		300,
		76
	],
	"./Portuguese/SafariP.png": [
		301,
		77
	],
	"./Portuguese/SamsungP1.png": [
		302,
		78
	],
	"./Portuguese/SamsungP2.png": [
		303,
		79
	],
	"./Spanish CA/DuckDuckGoCA.png": [
		311,
		80
	],
	"./Spanish CA/EdgeCA.png": [
		312,
		81
	],
	"./Spanish CA/FirefoxCA.png": [
		313,
		82
	],
	"./Spanish CA/OperaCA.png": [
		314,
		83
	],
	"./Spanish CA/SamsungCA1.png": [
		315,
		84
	],
	"./Spanish CA/SamsungCA2.png": [
		316,
		85
	],
	"./Spanish/DuckDuckGoS.png": [
		304,
		86
	],
	"./Spanish/EdgeS.png": [
		305,
		87
	],
	"./Spanish/FirefoxS.png": [
		306,
		88
	],
	"./Spanish/OperaS.png": [
		307,
		89
	],
	"./Spanish/SafariS.png": [
		308,
		90
	],
	"./Spanish/SamsungS1.png": [
		309,
		91
	],
	"./Spanish/SamsungS2.png": [
		310,
		92
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 223;
module.exports = webpackAsyncContext;